export default "__VITE_ASSET__C_06TOc4__"